import { useContext } from "react"
import { MarketingAutomaticoContext } from "./MarketingAutomaticoContext"

export function useMarketingAutomaticoContext() {
    return useContext(MarketingAutomaticoContext)
}
